import { motion } from 'framer-motion';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { useCreateItems } from 'global/cnr/contexts/useHelpers/useCreateItems';
import { convertHelpers } from 'global/common/convert';
import AppForm from 'global/components/forms/appForms/AppForm';
import { appFormTypes } from 'global/enums/appFormTypes';
import { appIconTypes } from 'global/enums/appIconTypes';
import { gEnums } from 'global/enums/globalEnums';
import { settingsIconTypes } from 'global/enums/settingsIconTypes';
import { listListO } from 'global/lists/lists';
import { settingsHelpers } from 'global/viewSettings/helpers/settingsHelpers';
import { propDataOpts } from 'global/viewSettings/settingsProps/settingsAll';
import _ from 'lodash';
import { _matchDisplayTypes, MatchContentWithProvider } from 'projectSpecific/sports/elements/matches/MatchContent';
import { useContext, useMemo, useRef, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Icon, Label } from 'semantic-ui-react'; // or your preferred icon library
import SortableGrid from 'SortableGrid';
import { _squareTypes } from './SquareSquares';
import { SquaresContext } from './SquaresWrapper';
import { LPW } from './LongPressWrapper';

const _iconSize = null

// Example transition — replace with your actual itemTransition if imported
const itemTransition = { duration: 0.25, ease: 'easeOut' };

export const _imsTypes = {
  dropdown: 'dropdown',
  dropup: 'dropUp',
  event: 'event',
  inline: 'inline',
  match: 'match',
  matchFull: 'matchFull',
  menu: 'menu',
  menuMini: 'menuMini',
  normal: 'normal',
  parent: 'parent',
  queryList: 'queryList',
  sortSelect: 'sortSelect',
  team: 'team',
}

const ItemMenuSquares = ({
  access,
  activeItem,
  activeItems,
  appDataDocuments,
  handleOnPress,
  allowDrag,
  longPressModal,
  caption,
  cn,
  columnCount,
  currentData,
  css,
  fn_preContent,
  fn_postContent,
  fn_altContent,
  fn_mainContent,
  fn_sort,
  fn_style,
  fn_beforeContent,
  fn_subContent,
  fn_subContentt,
  fn_icon,
  fnAltData,
  fns_image,
  group,
  handleSelect,
  icon: icon_main,
  iconColor: _iconColor,
  iconItem: icon_item,
  iconn: iconn_main,
  ignoreMotion,
  ignoreStartCase,
  imsType = _imsTypes.normal,
  isFull,
  isGlobal,
  itemMin,
  nameProp,
  keepCaption,
  menuItems,
  noGap,
  noItemIcon,
  onCancel,
  onClick,
  onDrop,
  onRemove,
  onSort,
  showItemKey,
  sortProp,
  squareType,
  style,
  style_item,
  withCancel,
}) => {

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state } = states ?? {}
  const { aps_global, aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});
  const { themeColors } = aps_global ?? {}

  const squaresContext = useContext(SquaresContext)
  const { squares_handlers } = squaresContext ?? {}

  const outerRef = useRef(null)
  const create_fns = useCreateItems()

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (files) => {
      onDrop(files)
    },
    accept: {
      'image/*': [],
      'application/pdf': [],
    },
    multiple: true,
  })

  const [showAdd, setShowAdd] = useState()
  const [showReorder, setShowReorder] = useState()

  const _menuItems = _.cloneDeep(menuItems)

  if (!_.isArray(_menuItems)) {
    convertHelpers.createItemKeys(_menuItems, 'key')
  }

  const start = performance.now();

  const ignoreIcon = imsType === _imsTypes.menu || imsType === _imsTypes.menuMini || imsType === _imsTypes.dropdown

  const isInline = useMemo(() => {
    let _isInline = imsType === _imsTypes.inline ||
      imsType === _imsTypes.dropdown ||
      imsType === _imsTypes.dropup ||
      imsType === _imsTypes.event ||
      imsType === _imsTypes.match ||
      imsType === _imsTypes.parent ||
      imsType === _imsTypes.queryList ||
      imsType === _imsTypes.sortSelect ||
      imsType === _imsTypes.team
    return _isInline
  }, [imsType])

  const { showShow, allowAltItem, allowAddItem, allowReorder } = useMemo(() => {

    let _allowSorting = false
    let _allowGroups = false
    let _showShow = false;
    let _allowSections = false
    let _allowAltItem = false
    let _allowAddItem = false

    switch (squareType) {
      case _squareTypes.pages_global:
        _allowAddItem = true
        break;
      case _squareTypes.pages_page:
        _allowGroups = true
        _allowSorting = true
        _showShow = true
        _allowAddItem = true
        break;
      case _squareTypes.pageProps:
        _allowGroups = isGlobal ? false : true
        _allowSorting = isGlobal ? false : true
        _showShow = true
        _allowAddItem = true
        _allowSections = fnAltData ? true : false
        break;
      case _squareTypes.pageSections:
        _allowSorting = true
        _showShow = true
        _allowAddItem = true
        _allowSections = fnAltData ? true : false
        break;
      case _squareTypes.pageItems:
        _allowAltItem = true
        break;
      default:
      // nothing
    }

    switch (imsType) {
      case _imsTypes.sortSelect:
        _allowSorting = true
    }

    let _allowReorder = _allowSorting || _allowGroups

    if (onSort) {
      _allowSorting = true
      _allowReorder = true
    }

    return { showShow: _showShow, allowGroups: _allowGroups, allowReorder: _allowReorder, allowSorting: _allowSorting, allowSections: _allowSections, allowAltItem: _allowAltItem, allowAddItem: _allowAddItem }
  }, [squareType, currentData])

  const handleShow_add = () => setShowAdd(!showAdd)

  const handleDragStart = ({ e, item }) => {
    e.dataTransfer.setData('application/json', JSON.stringify(item));
  };


  const cnc = [
    'item-menu-squares-container',
    imsType,
    !caption && 'nc',
    'srt',
    showReorder && ' srdr',
    css && css,
    (noGap && 'ng')
  ].filter(Boolean).join(' ')


  // return <div>TESTER</div>

  const handleCancel = (e) => {
    e && e.stopPropagation()
    onCancel()
  }

  const itemCaption = (content, item) => {
    if (!content) return;
    let cn = 'sqr-box-caption'
    if (item?.disabled) { cn += ' dsb' }
    if (fn_preContent || fn_postContent) { cn += ' clbls' }
    return <div className={cn}>
      <>
        {fn_preContent && fn_preContent(item)}
        {<div>{content}</div>}
        {fn_postContent && fn_postContent(item)}
      </>
    </div>
  }

  const item_icon = (item, itemKey, icon, iconColor, disabled, colors, controls) => <Icon
    className='ims-item-icon'
    name={appIconTypes[itemKey] || colors?.icon || icon}
    color={iconColor ? iconColor : controls ? 'blue' : 'blue'}
    size={_iconSize}
    disabled={disabled}
    circular={showShow}
    inverted={showShow && item.show}
    onClick={(e) => {
      e.stopPropagation()
      if (!controls && onCancel) handleCancel(e)
    }}
    style={controls ? { cursor: 'grab' } : {}}
    onPointerDownCapture={(e) => { if (controls) controls.start(e) }}
  />

  const item_label = (item, itemKey, icon, iconColor, disabled, colors, controls) => <Label
    className='ims-item-icon'
    size={'tiny'}
    color={'black'}
    disabled={disabled}
    circular={showShow}
    onClick={(e) => {
      e.stopPropagation()
      if (!controls && onCancel) handleCancel(e)
    }}
    style={controls ? { cursor: 'grab' } : {}}
    onPointerDownCapture={(e) => { if (controls) controls.start(e) }}
  >{item?.seed || item?.position}</Label>

  // this can be sortable
  const itemIcon = (item, itemKey, icon, iconColor, disabled, colors, controls) => {
    return <div className='sqr-box-icon'>
      {onSort ? item_label(item, itemKey, icon, iconColor, disabled, colors, controls) : item_icon(item, itemKey, icon, iconColor, disabled, colors, controls)}
    </div>
  }

  const removeIcon = (item, itemKey, icon, iconColor, disabled, colors) => <div className='sqr-box-icon'>
    <Icon
      className='ims-item-remove'
      name={appIconTypes[itemKey] || colors?.icon || icon}
      color={iconColor || 'blue'}
      size={_iconSize}
      disabled={disabled}
      circular={showShow}
      inverted={showShow && item.show}
      onClick={(e) => onRemove && onRemove(e, item)}
    />
  </div>

  const div_menu = (divProps) => {
    const { item, caption } = divProps
    const name = convertHelpers.getItemName(item, true, null, null, nameProp)
    return itemCaption(caption || name, item)
  }

  const div_dropdown = (divProps) => {
    const { item, caption } = divProps
    const name = convertHelpers.getItemName(item, true, null, null, nameProp)
    return itemCaption(caption || name)
  }

  const div_inline = (divProps) => {
    const { item, itemKey, caption, count, icon, iconColor, isHeader, altContent, disabled, colors, controls } = divProps
    const { color, label } = item ?? {}
    const name = convertHelpers.getItemName(item, true, null, null, nameProp)
    const icon_color = color || iconColor
    return <div className='sqr-box il'>
      {fns_image && fns_image(item)}
      {itemCaption(caption || name, item)}
      {!_.isNumber(count) && !isHeader && !noItemIcon && !fns_image && !ignoreIcon && itemIcon(item, itemKey, icon, icon_color, disabled, colors, controls)}
      {_.isNumber(count) && !isHeader && !fn_sort && <Label className='sqr-box-icon' circular size={'tiny'} color={count > 0 ? 'blue' : 'grey'}>{item.count}</Label>}
      {altContent && !isHeader && <div className='sqr-box-oth'>{altContent}</div>}
      {fn_altContent && !isHeader && <div className='sqr-box-oth'>{fn_altContent(item, itemKey)}</div>}
      {colors.bg &&
        <Label size='mini' className='sqr-box-oth' style={{ backgroundColor: colors.bg, color: colors.c }}>
          {'A'}
        </Label>}
      {label && label}
      {fn_subContent && !isHeader && <div className='sqr-box-sub il'>{fn_subContent(item, itemKey)}</div>}
      {fn_subContentt && !isHeader && fn_subContentt(item, itemKey)}
    </div>
  }

  const div_normal = (divProps) => {
    const { item, itemKey, caption, count, icon, isHeader, altContent, disabled, captionCount, colors, controls } = divProps
    return <div className='sqr-box mtl'>
      {itemCaption(caption)}
      {!_.isNumber(count) && !isHeader && !noItemIcon && !fns_image && itemIcon(item, itemKey, icon, _iconColor, disabled, colors, controls)}
      {_.isNumber(captionCount) && !isHeader && !noItemIcon && <Label className='sqr-box-oth' size={'mini'}>{captionCount}</Label>}
      {altContent && !isHeader && <div className='sqr-box-oth'>{altContent}</div>}
      {fn_altContent && !isHeader && <div className='sqr-box-oth'>{fn_altContent(item, itemKey)}</div>}
      {fn_subContent && !isHeader && <div className='sqr-box-sub nm'>{fn_subContent(item, itemKey)}</div>}
      {fn_subContentt && !isHeader && fn_subContentt(item, itemKey)}
    </div>
  }

  const div_match = (divProps) => {
    const { item, isHeader, itemKey } = divProps
    const { away, home, startDate, _itemKey } = item ?? {}
    const { name: name_away } = away ?? {}
    const { name: name_home } = home ?? {}
    const name = `${name_away || away} @ ${name_home || home}`
    return <div className='sqr-box mt'>
      {itemCaption(name || item?.key)}
      {fn_altContent && !isHeader && <div className='sqr-box-oth'>{fn_altContent(item, itemKey)}</div>}
      {fn_subContent && !isHeader && <div className='sqr-box-sub mt'>{fn_subContent(item, itemKey)}</div>}
      {!fn_subContent && !isHeader && <div className='sqr-box-sub mt'>{startDate}{showItemKey && `: ${_itemKey}`}</div>}
    </div>
  }

  const div_matchFull = (divProps) => {
    const { item } = divProps
    const propz = {
      matchDisplayType: _matchDisplayTypes.levelMatches,
      matchKey: item._itemKey,
      matchScheduleDisplayType: gEnums.matchScheduleDisplayTypes.levelDates
    }
    if (fn_subContent) {
      return <div>
        {fn_beforeContent && !isHeader && <div className='sqr-box-sub mt'>{fn_beforeContent(item, itemKey)}</div>}
        <MatchContentWithProvider {...propz} />
        <div className='sqr-box-sub il'>{fn_subContent(item, item._itemKey)}</div>
      </div>
    } else {
      return <MatchContentWithProvider {...propz} />
    }
  }

  const div_team = (divProps) => {
    const { item } = divProps
    const { name, sections, levels } = item ?? {}
    const caption = `${name} (${levels}-${sections})`
    return <div className='sqr-box te'
      draggable={allowDrag}
      onDragStart={(e) => handleDragStart({ e, item })}
    // onDragOver={handleDragOver}
    >
      {itemCaption(caption)}
    </div>
  }

  const div_event = (divProps) => {
    const { item, itemKey, icon, iconColor, disabled } = divProps
    const { name } = item
    return <div className='sqr-box evt'>
      {itemIcon(item, itemKey, icon, iconColor, disabled)}
      {itemCaption(name || item?.key)}
    </div>
  }

  const div_queryList = (divProps) => {
    const { item, itemKey } = divProps
    const { dataPropName, queryType, propValues, propValue, propStringValue, valueIsString } = item
    const appDd = appDataDocuments?.[dataPropName]
    const appDdii = appDd?.[propValue] ? appDd?.[propValue]?.name : propValue

    let _appDdi;

    if (propValues) {
      let _propValues = propValues
      if (_.isObject(_propValues)) {
        _propValues = _.values(_propValues);
      }
      _appDdi = _.join(
        _.map(_propValues, pv => appDd?.[pv]?.name),
        ','
      )
    } else {
      if (valueIsString) {
        _appDdi = propStringValue
      } else {
        _appDdi = appDdii
      }
    }

    const name = `${dataPropName} : ${queryType} : ${_appDdi}`

    return <div className='sqr-box evt'>
      {itemCaption(name || item?.key)}
      {removeIcon(item, itemKey, 'delete', 'red')}
    </div>
  }

  const div_childItem = (divProps) => {
    switch (imsType) {
      case _imsTypes.parent:
        return fn_mainContent(divProps)
      case _imsTypes.inline:
      case _imsTypes.sortSelect:
        return div_inline(divProps)
      case _imsTypes.normal:
        return div_normal(divProps)
      case _imsTypes.match:
        return div_match(divProps)
      case _imsTypes.matchFull:
        return div_matchFull(divProps)
      case _imsTypes.team:
        return div_team(divProps)
      case _imsTypes.event:
        return div_event(divProps)
      case _imsTypes.queryList:
        return div_queryList(divProps)
      case _imsTypes.menu:
      case _imsTypes.menuMini:
        return div_menu(divProps)
      case _imsTypes.dropdown:
        return div_dropdown(divProps)
      case _imsTypes.dropup:
        return div_dropdown(divProps)
      default:
        return div_inline(divProps)
    }
  }

  const start_case = (value) => {
    return ignoreStartCase ? value : _.startCase(value)
  }

  // each item will use this
  const renderIconDiv = (item, itemKey, controls) => {
    const {
      _isFirstItem,
      caption,
      count,
      data,
      disabled,
      icon,
      iconColor,
      isDrop,
      isHeader,
      key,
      selected,
      text,
      subText,
      triggerUrl,
      ui,
      altContent,
      display,
    } = item ?? {}

    const { caption: caption_display } = display ?? {}
    const name = convertHelpers.getItemName(item, true, false, true, nameProp)

    let altItem;

    if (allowAltItem && item.key === 'props') {
      altItem = _.cloneDeep(item)
      altItem.key = 'propSections'
      altItem.caption = 'Prop Sections'
    }

    let _caption;
    let _icon = withCancel ? 'delete' : icon_item ? icon_item : 'arrow right';
    let _iconColor;
    let _iconStyle;
    let _key;
    let _captionCount;
    let _selected = activeItem && ((activeItem === name) || activeItem === item || activeItem === key || activeItem === item?._itemKey)

    if (activeItems && _.find(activeItems, { _itemKey: item?._itemKey })) {
      _selected = true
    }

    if (activeItems && _.includes(activeItems, item?._itemKey)) {
      _selected = true
    }

    if (_.isObject(item)) {
      if (_.isObject(caption)) {
        _caption = caption.text || start_case(itemKey)
        _captionCount = caption?.count || null
      } else {
        _caption = caption || start_case(key) || start_case(itemKey)
      }
      if (icon) { _icon = icon }
      if (iconColor) { _iconColor = iconColor }
      if (key) { _key = key }
    } else {
      _caption = start_case(item)
    }

    if (fn_icon) {
      const { icon, iconColor, iconStyle } = fn_icon(item)
      _icon = icon
      _iconColor = iconColor
      _iconStyle = iconStyle
    }

    if (ui?.caption) { _caption = `${ui?.caption} - ${data?.formItemType}` }
    if (text) { _caption = `${text}` }
    if (name) { _caption = `${name}` }

    _caption = typeof _caption === 'string' && _caption.includes(',')
      ? _caption
      : start_case(_caption)

    if (caption_display && _.camelCase(caption_display) !== key) {
      _caption = `${caption_display} (${start_case(key)})`
    }

    const _cnd = [
      'imsc-item',
      selected && 'sel',
      isHeader && 'hdr',
      _selected && 'sel',
      currentData && currentData?.[key]?.allowAction && 'aa'
    ].filter(Boolean).join(' ')

    if (triggerUrl) { _iconColor = ' orange' }

    let _colors = { bg: null, c: null, icon: null }

    switch (group?.key) {
      case 'style':
      case 'styles':
      case 'themedColors':
      case 'themedItems':
        const propData = currentData?.[item.key]
        const { colors } = propData ?? {}
        const { backgroundColor, color } = colors ?? {}
        const _bgcolor = themeColors?.[backgroundColor]
        const _color = themeColors?.[color]
        _colors.bg = _bgcolor
        _colors.c = _color
        _colors.icon = settingsIconTypes[item.key]
        break;
      default:
      // nothing
    }

    const _isDrop = isDrop

    // on drop
    const grp = getRootProps()
    const _onClick = _isDrop ? grp.onClick : onClick
    delete grp.onClick

    const handle_click = (e, a, b) => {
      e && e.stopPropagation()
      _onClick && _onClick(a, b)
    }

    if (_isFirstItem) return (
      <motion.div>
        <div className='imsc-item-header'>
          {start_case(item?.propSection)}
        </div>
      </motion.div>
    )

    const divProps = {
      allowAltItem,
      altContent,
      caption: keepCaption ? caption : _caption,
      captionCount: _captionCount,
      colors: _colors,
      count,
      disabled,
      icon,
      icon: _icon,
      iconColor: _iconColor,
      iconStyle: _iconStyle,
      isHeader,
      item,
      itemKey,
      controls,
    }

    if (imsType === _imsTypes.matchFull) {
      return div_matchFull(divProps)
    }

    return (
      <motion.div
        key={itemKey}
        layout={!ignoreMotion}
        initial={{ opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 6 }}
        transition={itemTransition}
        style={fn_style ? fn_style(item) : style_item}
        className={`${_cnd} ${isDrop && isDragActive ? 'drag-active' : ''}`}
        onClick={(e) => handle_click && !disabled && !showReorder && !isHeader && handle_click(e, item, group)}
        {...(isDrop ? grp : {})}
      >
        {/* Dropzone input only for drop items */}
        {isDrop && <input {...getInputProps()} />}
        {div_childItem(divProps)}
        {subText && !isHeader && <div className='sqr-box-sub ims'>{subText} </div>}
      </motion.div >
    )
  };

  if (_.isEmpty(_menuItems)) { return; }

  let miCount = _.size(_menuItems)

  if (miCount > 3) { miCount = 3 }
  if (miCount === 1) { miCount = 2 }
  if (columnCount) { miCount = columnCount }

  const cni = [
    'imsc-row-item',
    `sz-${isInline ? 1 : miCount}`,
  ].filter(Boolean).join(' ')

  const cn_cap = [
    'imsc-caption',
  ].filter(Boolean).join(' ')

  const handle_ammendSort = (items) => {
    const _items = _.cloneDeep(items)
    setShowReorder()
    if (isGlobal) {
      squares_handlers.handleAmmend_updateViewItemsInViews(true, _items, true, squareType)
    } else {
      squares_handlers.handleAmmend_updateViewItemsInViews(false, _items, true, squareType)
    }
  }

  const content_add = () => {
    const hs = async (data) => {
      switch (squareType) {
        case _squareTypes.pages_global:
          const opts = { forGlobal: true, createGenericProps: true, createPropSections: true, count: _.size(aps_viewItems) + 1 }
          const vi = create_fns.createViewItem(data.name, opts)
          squares_handlers.handleAmmend_viewItem(data.name, vi)
          break;

        case _squareTypes.pages_page:
          const vipp = _.cloneDeep(aps_viewItems[data.name])
          vipp.dataConstraints = {
            usePageConstraint: true,
            usePostPageConstraint: true,
            pageConstraintType: gEnums.pageConstraintTypes.arrayContains,
          };
          _menuItems[data.name] = vipp
          _menuItems[data.name].position = _.size(_menuItems)
          const _items = _.cloneDeep(_menuItems)
          squares_handlers.handleAmmend_updateViewItemsInViews(_items)
          break;

        case _squareTypes.pageProps:
          const _existingProps = {}
          const propSection = {}
          const propsToAdd = {
            [data.name]: { key: data.name }
          }
          break;
      }
      handleShow_add()
    }
    const pd = {}

    switch (squareType) {
      case _squareTypes.pages_global:
        return <AppForm
          appFormType={appFormTypes.simpleInput}
          handleSave={hs}
          handleCancel={handleShow_add}
          data_parent={pd}
        />
      case _squareTypes.pages_page:
        const appFormItems = {
          name: settingsHelpers.newPropObject('name', propDataOpts(true, gEnums.formItemTypes.select, null, { trueList: listListO(aps_viewItems) })),
        }
        return <AppForm
          appFormItems={appFormItems}
          handleSave={hs}
          handleCancel={handleShow_add}
          data_parent={pd}
        />
    }
  }

  const content_sortable = () => {
    const menuItemz = _.sortBy(_menuItems, 'position')
    return <SortableGrid
      items={menuItemz}
      divFn={renderIconDiv}
      groupKey={group?.key}
      handleSorted={handle_ammendSort}
      handleSelect={handleSelect}
      imsType={imsType}
      onSort={onSort}
      showApply={true}
      showReorder={showReorder}
      allowReorder={allowReorder}
      sortProp={sortProp}
      squareType={squareType}
      fn_altContent={fn_altContent}
      cn={cn}
    />
  }

  const content_normal = () => {
    return _.map(_menuItems, (item, itemKey) => renderIconDiv(item, itemKey))
  }

  if (showAdd) {
    return content_add()
  }

  if (imsType === _imsTypes.matchFull) {
    return content_normal()
  }

  const content_main = () => <div
    ref={outerRef}
    className={cnc}
    style={style ? style : isFull ? { height: '100%', padding: '1em', overflowY: 'auto' } : {}}
  >
    {caption && <div className={`${cn_cap} sb`} >
      <div>
        <Icon name={icon_main} color={_iconColor || 'blue'} style={{ marginRight: '1em' }} />
        {caption}
        {allowAddItem && <Icon name={'add'} color={showAdd ? 'green' : 'grey'} style={{ marginLeft: '1em' }} onClick={() => handleShow_add()} />}
      </div>
      <div>
        {iconn_main && <Icon name={iconn_main} color={_iconColor || 'blue'} />}
        {access && <Icon name={access?.icon || 'user'} color={access?.color || 'blue'} />}
      </div>
    </div>}
    <div className={cni} >
      {content_normal()}
    </div>
  </div>

  const lpw = (content) => <LPW
    handleOnPress={handleOnPress}
    longPressModal={{ content: longPressModal() }}
  // disallowLpw={true}
  >
    {content}
  </LPW>

  if (allowReorder) {
    return <div
      className={cnc}
      ref={outerRef}>
      {caption && <div className={cn_cap}>
        {caption}
      </div>
      }
      <div className={cni} >
        {content_sortable()}
      </div>
    </div>
  } else {

    const duration = performance.now() - start;

    if (duration > 50) {
      // console.timeEnd("ItemMenuSquares");
      console.warn(`cloneDeep took ${duration.toFixed(2)} ms`);
    }

    return handleOnPress || longPressModal ? lpw(content_main()) : content_main()
  }

};

export default ItemMenuSquares;
